<template>
    <div>

        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-7">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card 
                                class="mb-4 mb-xl-0"
                    >
                      <center>
                      <h2 style='color: gray;'>Name</h2>
                      <h1>{{name}}</h1>
                    </center>
                      <!--   <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card 
                                class="mb-4 mb-xl-0"
                    >
                      <center>
                      <h2 style='color: gray;'>Phone</h2>
                      <br>
                      <h1 style='font-size:29px;line-height: 55px;'>{{phone_number}}</h1>

                    </center>
                      <!--   <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card 
                                class="mb-4 mb-xl-0"
                    >
                      <center>
                      <h2 style='color: gray;'>NavCode</h2>
                      <br>
                      <h1 style='font-size:36px;'>{{navcode}}</h1>
                    </center>
                      <!--   <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card 
                                class="mb-4 mb-xl-0"
                    >
                      <center>
                      <h2 style='color: gray;'>Accuracy</h2>
                      <br>
                      <h1 style='font-size:36px;'>{{accuracy}}</h1>
                    </center>
                      <!--   <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow border-0">
                        <div id="map-canvas" class="map-canvas" :data-lat="latitude" :data-lng="longitude" style="height: 400px;"></div>
                    </div>
                    <br>
                     <div class="col-xl-12 col-lg-6"">
                      <base-input alternative placeholder="Phone Number" v-model="phoneNo"></base-input>
                    </div>
                    <br>
                    <div>
                      <base-button class="col-xl-12 col-lg-6" type="success" style="height: 100px; font-size: 30px;" v-on:click="onDispatch()">Dispatch</base-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<!-- <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBUO-XA9PHJNEyFi7pQMYOhtfi7swKxu3w" ></script> -->
<!-- <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBUO-XA9PHJNEyFi7pQMYOhtfi7swKxu3w&callback=initMap"
    async defer></script>
<script>
      var map;
      function initMap() {
        map = new google.maps.Map(document.getElementById('map-canvas'), {
          center: {lat: -34.397, lng: 150.644},
          zoom: 8
        });
        const marker = new google.maps.Marker({
        position: {lat: -34.397, lng: 150.644},
        map: map,
        animation: google.maps.Animation.DROP,
        title: 'Hello World!'
      });
      }
    </script> -->
    
<script>
  import { mapGetters } from "vuex";
  import { mapState } from "vuex";
  import { GET_LOCATION, DISPATCH_TO_OFFICER } from "@/store/actions.type";

    import store from "@/store";

  export default {
    data() {
      return {
        name : '',
        phone_number : '',
        phoneNo : '',
        navcode : '',
        accuracy : '',
        latitude: 0.0,
        longitude : 0.0
      }
    },
    computed: {
        ...mapGetters(["isAuthenticated", "overview"])
        // ,
        // subscribers() {
        //     console.log(this.$route.params.subscribers);
        //   return this.$route.params.subscribers;
        // }
      },
    mounted() {
      Promise.all([
        store.dispatch(GET_LOCATION, this.$route.params.token)
      ]).then((response) => {
          this.loaded = true;
          console.log(response);
          if (response[0].errFlag === 0) {
                this.name = response[0].data.name;
                this.phone_number = response[0].data.phone_number;
                this.navcode = response[0].data.navcode;
                this.latitude = response[0].data.latitude;
                this.longitude = response[0].data.longitude;
                this.accuracy = response[0].data.accuracy;
                  let google= window.google
                  let map = document.getElementById('map-canvas');
                  let lat = response[0].data.latitude;
                  let lng = response[0].data.longitude;

                  const myLatlng = new google.maps.LatLng(lat, lng);
                  const mapOptions = {
                    zoom: 18,
                    scrollwheel: false,
                    center: myLatlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                    // ,
                    // styles: [
                    //   {"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},
                    //   {"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},
                    //   {"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},
                    //   {"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},
                    //   {"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},
                    //   {"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},
                    //   {"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},
                    //   {"featureType":"water","elementType":"all","stylers":[{"color":'#5e72e4'},{"visibility":"on"}]}]
                  }

                  map = new google.maps.Map(map, mapOptions);

                  const marker = new google.maps.Marker({
                    position: myLatlng,
                    map: map,
                    animation: google.maps.Animation.DROP,
                    title: 'Hello World!'
                  });

                  const contentString = '<div class="info-window-content"><h2>Argon Dashboard</h2>' +
                    '<p>A beautiful Dashboard for Bootstrap 4. It is Free and Open Source.</p></div>';

                  const infowindow = new google.maps.InfoWindow({
                    content: contentString
                  });

                  google.maps.event.addListener(marker, 'click', function() {
                    infowindow.open(map, marker);
                  });
                      }
                      // console.log(this.stores);
                      // console.log(this.visitsdata);
                      // this.initBigChart(this.stores[0]);
                      // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
                      // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
                      // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
                  });

        
        // console.log(this.loaded);
        // this.getSubscribers();
        // console.log(this.loaded);
      
      // this.loaded = false;
      // console.log(this.subscribers);
        
        // this.loaded = false;

      // console.log(data);
      
    },
    methods : {
      onDispatch() {
        if (this.phoneNo != '') {
          Promise.all([
        store.dispatch(DISPATCH_TO_OFFICER, {"navcode" : this.navcode, "phone_number" : this.phoneNo})
      ]).then((response) => {



        this.$router.push({ name: "overview" })
      });
        }
        

         

        // var pubnub = new PubNub({
        //     publishKey: "pub-c-19662d2f-1d79-4568-a018-e352b0af2171",
        //     subscribeKey: "sub-c-9185b126-23bc-11e9-bb27-2e4c7f2c8bda"
        // });
        // var publishConfig = {
        //     channel : "911_dispatch",
        //     message: { 
        //         name: this.name,
        //         phone_number: this.phone_number,
        //         latitude : this.latitude,
        //         longitude : this.longitude
        //     }
        // }
        // pubnub.publish(publishConfig, function(status, response) {
        //     console.log(status, response);
        // })
            
              
        // pubnub.addListener({
        //     status: function(statusEvent) {
        //         if (statusEvent.category === "PNConnectedCategory") {
        //             // publishSampleMessage();
        //         }
        //     },
        //     message: function(msg) {
        //         console.log(msg.message);
        //         onPubnub(msg);
                
        //     },
        //     presence: function(presenceEvent) {
        //         // handle presence
        //     }
        // })      
        // pubnub.subscribe({
        //     channels: ['911_channel'] 
        // });

      }
    }
    
  }
</script>

<style>
</style>
